export const FOXTROT_DEFAULT_EVENT_DATA = {
	groupingKey: 'groupingKey',
	farmId: 'nm5',
	eventSchemaVersion: 'v1',
	eventTTLBucket: 'MEDIUM',
	eventCriticalityBucket: 'MEDIUM',
};

export const FOXTROT_DEFAULT_CONFIG = {
	flushInterval: 5,
	schemaName: 'STREAMS_EVENT',
	sensitivity: 'LOW',
};

// Network events

export const API_LATENCY = 'API_LATENCY';
